import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AuthLayout from '../components/layout/authlayout';
import Input from '../components/common/input';
import Button from '../components/common/button';
import { forgotPassword as forgotPasswordAction } from '../store/actions/authActions';
import { forgotPasswordSchema, validateWithZod } from '../validators/authValidator';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setEmail(e.target.value);
    if (error) setError('');
  };

  const validateForm = () => {
    const validation = validateWithZod(forgotPasswordSchema, { email });

    if (!validation.success) {
      const fieldErrors = validation.errors;
      if (fieldErrors.email) {
        setError(fieldErrors.email);
      }
      return null;
    }

    setError('');
    return validation.data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validatedData = validateForm();
    if (!validatedData) {
      return;
    }

    try {
      await dispatch(forgotPasswordAction(validatedData.email, navigate));
    } catch (error) {
      console.error('Forgot password error:', error);
    }
  };

  return (
    <AuthLayout
      title="Forgot Password?"
      subtitle="Enter the email address associated with your account and we'll send you a code to reset your password"
    >
      <form onSubmit={handleSubmit} className="space-y-4" noValidate>
        <Input
          label="Email address"
          type="email"
          name="email"
          value={email}
          onChange={handleChange}
          placeholder="abc@gmail.com"
          error={error}
          required
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
          }
        />

        <Button
          type="submit"
          fullWidth
          loading={loading}
          disabled={loading}
        >
          Send Reset Code
        </Button>

        <div className="text-center">
          <Link
            to="/signin"
            className="text-sm text-gray-600 hover:text-primary transition-colors inline-flex items-center gap-1"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
            Back to Sign In
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword;